@let boundData = bound();

<section class="ps-small-x ps-small-t" [attr.data-testid]="'bound-section-' + boundData.id">
  <fin-shopping-cart-bound-header [bound]="boundData" (openItineraryDetails)="openItineraryDetails.emit()" />
  <fin-shopping-cart-bound-fare
    [bound]="boundData"
    [selectedPassengerId]="selectedPassengerId()"
    [price]="price()"
    [passengerCount]="passengerCount()"
    (openFareFamilyDetails)="openFareFamilyDetails.emit()"
  />
  <fin-shopping-cart-bound-services [bound]="boundData" [selectedPassengerId]="selectedPassengerId()" />
  <div class="separator ps-xxsmall-y border-bottom-dashed"></div>
</section>
